import actionTypes from "../actionTypes";

// ROUTES
import Routes from "../../constants/Routes";

// UTILS
import * as zmluvyUtils from "../../utils/zmluvy/zmluvyUtils";

// ACTIONS
import * as appHeaderActions from "../appHeaderActions";
import * as fakturyActions from "../faktury/fakturyActions";
import * as odberneMiestaActions from "../odberneMiesta/odberneMiestaActions";

export const updateCustomFiltersZmluvy = ({ customFilters }) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_CUSTOM_FILTERS_ZMLUVY,
      customFilters,
    });
  };
};

// SUPPORT METHODS
const isStringInURL = (value) => window.location.href.includes(value);
const buildFilter = (field, operator, value) => ({ field, operator, value });

// UPDATE DATA METHODS
const updateOMHeaderAndChangeOM = async (dispatch, gridProps) => {
  const action = appHeaderActions.getListOMHeaderAndChangeOM;
  await dispatch(action(gridProps));
};
const changeOM = async (dispatch, OM) => {
  const action = odberneMiestaActions.changeOM;
  await dispatch(action({ OM }));
};
// IF GRID IS RENDERED - UPDATE GRID DATA AND CUSTOM FILTERS
// ELSE - UPDATE CUSTOM FILTERS
const updateOMGridOrCustomFilters = async (dispatch, gridProps) => {
  const action = isStringInURL(Routes.ODBERNE_MIESTA)
    ? odberneMiestaActions.getListOM
    : odberneMiestaActions.updateCustomFiltersOM;

  await dispatch(action(gridProps));
};
const updateFakturyGridOrCustomFilters = async (dispatch, gridProps) => {
  const action = isStringInURL(Routes.FAKTURY)
    ? fakturyActions.getListFaktura
    : fakturyActions.updateCustomFiltersFaktury;

  await dispatch(action(gridProps));
};
export const changeZmluva = (
  { zmluva, grids },
  isPickedByDoubleClickInGridRow = false
) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_ZMLUVA,
      data: zmluva,
      isPickedByDoubleClickInGridRow,
    });

    const I_ORGAN = zmluva?.I_ORGAN || null;
    const I_ZMLUVY = zmluva?.I_ZMLUVY || null;

    if (I_ORGAN && I_ZMLUVY) {
      // build filters
      const fI_ORGAN = buildFilter("I_ORGAN", "eq", I_ORGAN);
      const fI_ZMLUVY = buildFilter("I_ZMLUVY", "eq", I_ZMLUVY);

      let customFilters = [{ ...fI_ORGAN }, { ...fI_ZMLUVY }];
      let gridProps = { grids, customFilters };

      await updateOMHeaderAndChangeOM(dispatch, gridProps);

      gridProps = { ...grids.OM, customFilters };
      await updateOMGridOrCustomFilters(dispatch, gridProps);

      customFilters = [{ ...fI_ZMLUVY }];
      gridProps = { ...grids.faktury, customFilters };
      await updateFakturyGridOrCustomFilters(dispatch, gridProps);
    } else {
      await changeOM(dispatch, { I_ZIS_OM: null, NAZOV: "..." });
    }
  };
};

const getZmluvaRequest = () => ({
  type: actionTypes.GET_ZMLUVA_REQUEST,
});
const getZmluvaSuccess = (res) => ({
  type: actionTypes.GET_ZMLUVA_SUCCESS,
  res,
});
const getZmluvaFailure = (error) => ({
  type: actionTypes.GET_ZMLUVA_FAILURE,
  error,
});
export const getZmluva = (id) => {
  return async (dispatch) => {
    try {
      dispatch(getZmluvaRequest());
      let res = await zmluvyUtils.getZmluva(id);
      dispatch(getZmluvaSuccess(res));
    } catch (error) {
      dispatch(getZmluvaFailure(error));
    }
  };
};

const getListZmluvaRequest = () => ({
  type: actionTypes.GET_LIST_ZMLUVA_REQUEST,
});
const getListZmluvaSuccess = (
  res,
  gridFilter,
  gridSort,
  gridPage,
  customFilters
) => ({
  type: actionTypes.GET_LIST_ZMLUVA_SUCCESS,
  gridFilter,
  gridSort,
  gridPage,
  customFilters,
  res,
});
const getListZmluvaFailure = (error) => ({
  type: actionTypes.GET_LIST_ZMLUVA_FAILURE,
  error,
});
export const getListZmluva = ({
  gridFilter,
  gridSort,
  gridPage,
  customFilters,
}) => {
  return async (dispatch) => {
    try {
      dispatch(getListZmluvaRequest());

      const filter = { filters: [...gridFilter.filters, ...customFilters] };
      let res = await zmluvyUtils.getListZmluva(filter, gridSort, gridPage);

      dispatch(
        getListZmluvaSuccess(res, gridFilter, gridSort, gridPage, customFilters)
      );
    } catch (error) {
      dispatch(getListZmluvaFailure(error));
    }
  };
};
